import React from 'react';

const GeneralPolicyContent = () => {
    return (
        <div className="space-y-4 text-foreground">
            <div className="h-[60vh] max-h-[75vh] space-y-4 overflow-y-scroll border border-gray-300 p-4">
                <p className="text-sm">
                    Lithion Battery Inc. (“Lithion,” “our,” “us,” or “we”) is
                    committed to protecting the privacy and security of the
                    information of our mobile application users (“you”). We want
                    you to understand how we collect and use information from
                    our mobile application (“App”) and our related services,
                    (together with the App, the “Services”) so you can interact
                    with us with confidence. By using the Services, you accept
                    and agree to the practices this Privacy Policy describes. If
                    you do not agree to any of the terms in this Privacy Policy,
                    you should not use the Services.
                </p>
                <h3 className="text-lg font-semibold">
                    What Information Do We Collect?
                </h3>
                <p className="text-sm">
                    When you use our Services, we may collect, store, and
                    process various kinds of data, including Personal
                    Information about you. “Personal Information” refers to
                    information about you that can be used to identify you, such
                    as your name, address, telephone number, e-mail address,
                    credit card information, or transaction information.
                </p>
                <ul className="list-disc space-y-2 pl-6 text-sm">
                    <li>Register on the App;</li>
                    <li>Submit a form on the App;</li>
                    <li>Contact us with inquiries, including via email;</li>
                    <li>
                        Subscribe to our newsletter or otherwise sign up to
                        receive communications; or
                    </li>
                    <li>Voluntarily provide information.</li>
                </ul>
                <p className="text-sm">
                    We may also collect details of your visit to our App and the
                    pages you access, including, but not limited to, traffic
                    data, location data, weblogs and other communication data,
                    including your IP address, browser type, the date and time
                    you accessed or left the App, and which pages you viewed.
                    Some parts of our App use cookies and other technologies to
                    collect this information about your general internet usage.
                    See the section below called “How We Use Tracking
                    Technologies” to learn more.
                </p>
                <h3 className="text-lg font-semibold">
                    Why We Collect Information
                </h3>
                <ul className="list-disc space-y-2 pl-6 text-sm">
                    <li>To present our Services to you;</li>
                    <li>To personalize your experience;</li>
                    <li>
                        To provide you with information or services that you
                        request from us;
                    </li>
                    <li>
                        To fulfill any other purpose for which you provide it;
                    </li>
                    <li>
                        To notify you about changes to our Services we offer;
                    </li>
                    <li>
                        To allow you to participate in any interactive features
                        on our Services;
                    </li>
                    <li>To improve our Services;</li>
                    <li>
                        To perform analytics to learn about the behavior of our
                        Service users;
                    </li>
                    <li>
                        To send periodic emails relating to occasional company
                        news, updates, or related information;
                    </li>
                    <li>
                        With your permission, we may send you marketing emails
                        about our Services and other updates;
                    </li>
                    <li>
                        To evaluate or conduct a merger, divestiture,
                        restructuring, reorganization, dissolution, or other
                        sale or transfer of some or all of our assets, whether
                        as a going concern or as part of bankruptcy,
                        liquidation, or similar proceeding, in which personal
                        information held by us about our App visitors is among
                        the assets transferred.
                    </li>
                </ul>
                <h3 className="text-lg font-semibold">
                    How Do We Protect Your Information?
                </h3>
                <p className="text-sm">
                    To protect your Personal Information, we take commercially
                    reasonable precautions and follow industry best practices to
                    make sure it is not inappropriately lost, misused, accessed,
                    disclosed, altered, or destroyed. However, no data
                    protection procedures are entirely infallible. As a result,
                    while we strive to protect your Personal Information, we
                    cannot guarantee that it will be 100% secure. Your
                    transmission of your information to our Platform thus is
                    done entirely at your own risk.
                </p>
                <h3 className="text-lg font-semibold">Contact Us</h3>
                <p className="text-sm">
                    We welcome any questions, comments, or complaints you may
                    have regarding this Privacy Policy.
                    <br />
                    Please do not hesitate to contact us by email at{' '}
                    <a
                        href="mailto:legal@lithionbattery.com"
                        className="text-blue-600 underline"
                    >
                        legal@lithionbattery.com
                    </a>{' '}
                    or by writing to us:
                </p>
                <p className="text-sm">
                    Lithion Battery Inc.
                    <br />
                    1350 Wigwam Parkway
                    <br />
                    Henderson, NV 89074
                    <br />
                    USA
                </p>
            </div>
        </div>
    );
};

export default GeneralPolicyContent;
